import TextareaEditorManager from "./TextareaEditorManager";

export default TextareaEditorManager;
export { TextareaEditorManager };
